import useAuth from '../hooks/useAuth';
import { COUNTRY_SPECIFIC_FEATURES } from '../enums/shared.enums';
import FeatureUnavailable from '../components/FeatureUnavailable';

type CountryFeatureGuardProp = {
    features?: COUNTRY_SPECIFIC_FEATURES[];
    children: React.ReactNode;
};

export default function CountryFeatureGuard({ features, children }: CountryFeatureGuardProp) {
    const { user } = useAuth();

    const isFeatureSupported = (feature: COUNTRY_SPECIFIC_FEATURES): boolean => {
        if (!user?.country) return false;

        switch (feature) {
            case COUNTRY_SPECIFIC_FEATURES.THERAPY:
                return user.country.isTherapySupported;
            default:
                return false;
        }
    };

    if (typeof features !== 'undefined' && features.length > 0) {
        const hasAccess = features.every(isFeatureSupported);

        if (!hasAccess) {
            return <FeatureUnavailable />;
        }
    }

    return <>{children}</>;
}
